import { combineReducers } from '@reduxjs/toolkit';

import button from './sections/button/buttonReducer.js';
import content from './sections/content/contentReducer.js';
import digital from './sections/digital/digitalReducer.js';
import footer from './sections/footer/footerReducer.js';
import header from './sections/header/headerReducer.js';
import image from './sections/image/imageReducer.js';
import links from './sections/links/linksReducer.js';
import spacer from './sections/spacer/spacerReducer.js';
import text from './sections/text/textReducer.js';
import videos from './sections/videos/videosReducer.js';

export const emailsSections = combineReducers({
  text,
  header,
  button,
  spacer,
  image,
  footer,
  digital,
  videos,
  links,
  content,
});
